export const environment = {
  production: false,
  authDomain: 'rex-login-dev01.cascadedesigns.com',
  authAudience: 'https://rexclientapi-dev.cascadedesigns.com',
  authClientId: 'O1hrwkeUMHW8Zt4nNoScX62RA4w7cXmH',
  authScope: 'openid profile create read update delete',
  redirect_uri: 'https://reports-dev.cascadedesigns.com',
  api_url: 'https://cdireportsapi-dev.cascadedesigns.com/api',
};
